// extracted by mini-css-extract-plugin
export default {"error-boundary":"error-boundary_error-boundary__BdLV4"};